import { useRef } from 'react'
import { Terminal } from 'lucide-react'
import { GlobalEvents } from '@highlight/ipc'
import { useGlobalEvent } from '@highlight/ipc/react'
import { ClientToolApprovalToast } from '../toasts/client-tool-approval-toast'
import { toastManager } from '../toast-store'
import { useToast } from '../use-toast'

type ToastApi = ReturnType<typeof useToast>

export function useClientToolToasts(toast: ToastApi) {
  const approvalRespondedRef = useRef(new Set<string>())

  useGlobalEvent(
    'client-tool:approval-request',
    (payload: { id: string; toolset: string; tool: string; input: Record<string, unknown> }) => {
      const toastKey = `client-tool-approval-${payload.id}`

      const onTimeout = () => {
        toastManager.dismiss(toastKey)
      }
      GlobalEvents.once(`client-tool:approval-timeout:${payload.id}`, onTimeout)

      toast.add({
        analytics: { type: 'client tool approval', toolset: payload.toolset, tool: payload.tool },
        id: toastKey,
        icon: <Terminal className="size-4" />,
        title: `Highlight wants to run ${payload.tool}`,
        duration: Infinity,
        autoExpandDelayMs: 0,
        onDismiss: () => {
          GlobalEvents.off(`client-tool:approval-timeout:${payload.id}`, onTimeout)
          if (approvalRespondedRef.current.has(payload.id)) return
          approvalRespondedRef.current.add(payload.id)
          GlobalEvents.emit(`client-tool:approval-response:${payload.id}`, { approved: false })
        },
        body: (toastId) => (
          <ClientToolApprovalToast
            toastId={toastId}
            requestId={payload.id}
            toolset={payload.toolset}
            tool={payload.tool}
            input={payload.input}
            onRespond={() => approvalRespondedRef.current.add(payload.id)}
          />
        ),
      })
    },
  )
}
